import React, {Component} from "react";

class Welcome extends Component {

    render() {
        var name = sessionStorage.getItem('name');

        return (
            <h2 className="staff_greeting">Welcome <i>{name}</i> to the admin reports service !</h2>
            // <h2 className="staff_greeting">Welcome to the admin reports service !</h2>
        )
      }

}

export default Welcome;
